import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  ResolvedQuestions,
} from 'Views/Page/Content/Templates/pm2JourneyMemberQuestionsChecklistTemplate/resolvedQuestions';

export const metaOverrideSet = buildBaseOverrides()
  .nameOverride('resolvedQuestions', {
    _component: () => ResolvedQuestions,
  }, overrideReadOnly);
